// extracted by mini-css-extract-plugin
export default {"knobWrapper":"Knob_knobWrapper__2jt-v","knob":"Knob_knob__n3VwQ","knobLabel":"Knob_knobLabel__EL8GQ"};